import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SessionExpirationService {
  private navigating = false;

  constructor(private readonly router: Router) {}

  showExpiredPage(reason: 'token-expired' | 'refresh-failed' | 'unauthorized'): void {
    if (this.navigating || this.router.url.startsWith('/session-expired')) return;

    this.navigating = true;
    const returnUrl = this.safeReturnUrl(this.router.url);
    console.warn('[AUTH_SESSION_EXPIRED]', { reason, returnUrl });
    void this.router.navigate(['/session-expired'], {
      queryParams: { returnUrl },
      replaceUrl: true,
    }).finally(() => {
      this.navigating = false;
    });
  }

  reset(): void {
    this.navigating = false;
  }

  private safeReturnUrl(value: string): string {
    const candidate = String(value || '').trim();
    return candidate.startsWith('/')
      && !candidate.startsWith('//')
      && !candidate.startsWith('/session-expired')
      ? candidate
      : '/main';
  }
}
